import { t } from 'i18next';

import { SolveProblemsStep } from 'bom/enums';
import { IImportProblems } from 'bom/types';
import { isEmptyObject } from 'core/utils';

export const getStepSubtitle = (problems: IImportProblems, type: SolveProblemsStep) => {
  if (isEmptyObject(problems[type])) {
    return '';
  }

  return t('labelFieldsWithValue', {
    count: problems[type].unsolved,
  });
};

export const isStepCompleted = (problems: IImportProblems, type: SolveProblemsStep) => {
  if (isEmptyObject(problems[type])) {
    return false;
  }

  return problems[type].unsolved === 0;
};
